import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const BarraLateralHeladeria = () => {
    const location = useLocation();
    
    // Auth check
    const user = JSON.parse(localStorage.getItem('user'));
    const roleName = user?.role_details?.name;
    const isAdmin = roleName === 'SUPER_ADMIN' || roleName === 'ADMIN_HELADERIA' || user?.is_superuser;

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                Comida Rápida
            </div>
            <ul className="sidebar-nav">
                <li className={isActive('/heladeria')}>
                    <Link to="/heladeria">Panel Principal</Link>
                </li>
                <li className={isActive('/heladeria/pos')}>
                    <Link to="/heladeria/pos">Punto de Venta</Link>
                </li>
                <li className={isActive('/heladeria/orders')}>
                    <Link to="/heladeria/orders">Órdenes</Link>
                </li>
                <li className={isActive('/heladeria/inventory')}>
                    <Link to="/heladeria/inventory">Menú</Link>
                </li>
                {/* {isAdmin && (
                    <li className={isActive('/heladeria/promotions')}>
                        <Link to="/heladeria/promotions">Promociones</Link>
                    </li>
                )} */}
                <li className={isActive('/heladeria/bodega')}>
                    <Link to="/heladeria/bodega">Bodega (Insumos)</Link>
                </li>
                {/* <li className={isActive('/heladeria/mezclas')}>
                    <Link to="/heladeria/mezclas">Mezclas</Link>
                </li> */}
                <li className={isActive('/heladeria/customers')}>
                    <Link to="/heladeria/customers">Clientes</Link>
                </li>
                <li className={isActive('/heladeria/shift')}>
                    <Link to="/heladeria/shift">Caja</Link>
                </li>
                <li className={isActive('/heladeria/gastos')}>
                    <Link to="/heladeria/gastos">Gastos</Link>
                </li>
                <li className={isActive('/heladeria/periodic-reports')}>
                    <Link to="/heladeria/periodic-reports">Reportes Periódicos</Link>
                </li>
                <li className={isActive('/heladeria/sync')}>
                    <Link to="/heladeria/sync">Sincronización</Link>
                </li>
                <li className={isActive('/heladeria/printers')}>
                    <Link to="/heladeria/printers">Impresoras</Link>
                </li>
            </ul>
        </aside>
    );
};

export default BarraLateralHeladeria;